import gsap from "gsap";


export default class PrivacyPolicy{

    constructor(){
        this._init();
    }

    _init(){
        this.$agree = document.querySelector('.js-privacy-agree');
        this.$mail = document.querySelector('.js-privacy-mail');
        this.$main = document.querySelector('.privacy__main');

        this._checkContact();
        this._setAnchor();
    }


    _checkContact(){

        this.$agree.addEventListener('change', ()=>{

            if(this.$agree.checked){
                this.$mail.classList.remove('-disabled');
            }
            else{
                this.$mail.classList.add('-disabled');
            }
        });
    }


    _setAnchor(){

        [...document.querySelectorAll('.privacy-anchor')].forEach($a=>{

            $a.addEventListener('click', e=>{
                e.preventDefault();

                const $target = document.querySelector($a.getAttribute('href'));
                const st = $target.getBoundingClientRect().top + this.$main.scrollTop - this.$main.getBoundingClientRect().top;
                gsap.to(this.$main, { duration:0.7, scrollTop:st, ease:"power2.out" });
            });
        });
    }
}